module.exports = __webpack_public_path__ + "themify.woff?a1ecc3b826d01251edddf29c3e4e1e97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/themify.woff?-fvbane
// module id = 925
// module chunks = 27